// extracted by mini-css-extract-plugin
export default {"wrapperInfoIcon":"style_wrapperInfoIcon__omNQJ","info":"style_info__Z+-Bq"};